import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppraisalService } from '../services/appraisal.service';

@Component({
  selector: 'app-self-appraisal',
  templateUrl: './self-appraisal.component.html',
  styleUrls: ['./self-appraisal.component.css']
})
export class SelfAppraisalComponent implements OnInit {
  clickStatus = false;
 alreadySubmit = false;
 alreadyDraft = false;
 showAppraisalForm = false;
 message = '';
  userData = {
    form_id : '',
    employee_code: '',
    employee_name : '',
    appraisal_period : '',
    form_type : '',
    employee_qualification : '',
    employee_designation : '',
    employee_department : '',
    employee_division : '',
    employee_grade : '',
    employee_DOB : '',
    employee_DOA : '',
    employee_LPM : '',
    employee_tasks : '',
    employee_achivements : '',
    employee_contributions_during_period : '',
    employee_contributions_file : '',
    employee_overcome_difficulties : '',
    help_from_supervising_officer : '',
    employee_scope_of_improvement : '',
    employee_suggestion : '',
    is_submit : '0',
    signature_date : '',
    entry_date : '',
    

  }

  constructor( private apprais : AppraisalService, private router: Router ) { }

  ngOnInit() {
    var user = this.apprais.getSelfInfo().subscribe(res=>{

       
        //console.log(res);
        this.userData.form_id = res.user.id;
        this.userData.employee_code = res.user.employee_code;
        this.userData.employee_name = res.user.employee_name;
        this.userData.appraisal_period = res.appraisalYear;
        this.userData.form_type = '1';
        this.userData.employee_qualification = res.user.qualification;
        this.userData.employee_designation = res.user.designation;
        this.userData.employee_department = res.user.department_name;
        this.userData.employee_division = res.user.division;
        this.userData.employee_grade = res.user.grade;
        this.userData.employee_DOB = this.dateFun(res.user.DOB);
        this.userData.employee_DOA = this.dateFun(res.user.DOA);
        this.userData.employee_LPM = this.dateFun(res.user.LPM);
        this.userData.employee_tasks = res.user.employee_tasks;
        this.userData.employee_achivements = res.user.employee_achivements;
        this.userData.employee_contributions_during_period = res.user.employee_contributions_during_period;
        this.userData.employee_overcome_difficulties = res.user.employee_overcome_difficulties;
        this.userData.help_from_supervising_officer = res.user.help_from_supervising_officer;
        this.userData.employee_scope_of_improvement = res.user.employee_scope_of_improvement;
        this.userData.employee_suggestion = res.user.employee_suggestion;
        this.userData.is_submit = res.user.is_submit;
        this.showAppraisalForm = res.showAppraisalForm;
        this.message = res.message;
        
        
    })
  }
  dateFun(dateStr)
  {
    var dateObj = new Date(dateStr);
    var month = dateObj.getMonth()+1; //months from 1-12
    var day = dateObj.getDate();
    var year = dateObj.getFullYear();
    
    var newdate = year + "-" + month + "-" + day;
    //console.log(newdate);
    return newdate;
    
  }
  isValid(selfAppraisalForm,control) 
  {
   
    if((!selfAppraisalForm.controls[control].valid && (selfAppraisalForm.controls[control].dirty ||selfAppraisalForm.controls[control].touched)) || (!selfAppraisalForm.controls[control].valid && this.clickStatus))
    {
       //var errorStr = '<div class="alert alert-danger"> * ' + control+ ' is required</div>';
       var errorStr = '<div class="alert alert-danger"> * ' + 'This field is required</div>';
      return errorStr;
    }
  }
  onDraft(selfAppraisalForm)
  {
     //console.log(this.userData);
     this.alreadyDraft = true;
     var selfData = this.apprais.setSelfAppraisalData(this.userData).subscribe( res => {
      localStorage.setItem('dashboard_msg',res.message);
      this.router.navigate(['/dashboard']);
     })
  }
  onSubmit(selfAppraisalForm)
  {
    this.clickStatus = true;
    if(selfAppraisalForm.valid)
    {
     this.alreadySubmit = true;

     //console.log(this.userData);
     this.userData.is_submit = '1';
     var selfData = this.apprais.setSelfAppraisalData(this.userData).subscribe( res => {
      localStorage.setItem('dashboard_msg',res.message);
      this.router.navigate(['/dashboard']);
     })
  }
}

conFun(selfAppraisalForm)
{
  var r = confirm("Are you sure to submit the review?");
  if (r == true) {
    this.onSubmit(selfAppraisalForm);
  }
}

}



// WEBPACK FOOTER //
// ./src/app/self-appraisal/self-appraisal.component.ts